<template>
  <div class="full-box" :class="className">
    <!--左上边框-->
    <div class="t_line_box">
      <i class="t_l_line"></i>
      <i class="l_t_line"></i>
    </div>
    <!--右上边框-->
    <div class="t_line_box">
      <i class="t_r_line"></i>
      <i class="r_t_line"></i>
    </div>
    <!--左下边框-->
    <div class="t_line_box">
      <i class="l_b_line"></i>
      <i class="b_l_line"></i>
    </div>
    <!--右下边框-->
    <div class="t_line_box">
      <i class="r_b_line"></i>
      <i class="b_r_line"></i>
    </div>

    <div class="full-box_title" v-if="title">
      <span>
        <i><img src="~@/assets/images/fullScreen/icon.png"/></i>
        {{ title }}
      </span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less" scoped>
.full-box {
  border: 1px solid #2c58a6;
  position: relative;
  box-shadow: 0 0 10px #2c58a6;
  background: rgba(6, 48, 109, 0.5);
  .t_line_box {
    position: absolute;
    width: 100%;
    height: 100%;
    i {
      background-color: #4788fb;
      box-shadow: 0px 0px 10px #4788fb;
      position: absolute;
    }
    .l_t_line {
      width: 5px;
      height: 24px;
      left: -3px;
      top: -3px;
    }
    .t_l_line {
      height: 5px;
      width: 26px;
      left: -3px;
      top: -3px;
    }
    .t_r_line {
      height: 5px;
      width: 26px;
      right: -3px;
      top: -3px;
    }
    .r_t_line {
      width: 5px;
      height: 24px;
      right: -3px;
      top: -3px;
    }
    .l_b_line {
      width: 5px;
      height: 24px;
      left: -3px;
      bottom: -3px;
    }
    .b_l_line {
      height: 5px;
      width: 26px;
      left: -3px;
      bottom: -3px;
    }
    .r_b_line {
      width: 5px;
      height: 24px;
      right: -3px;
      bottom: -3px;
    }
    .b_r_line {
      height: 5px;
      width: 26px;
      right: -3px;
      bottom: -3px;
    }
  }
  .full-box_title {
    position: absolute;
    top: -17px;
    left: 0;
    width: 100%;
    text-align: center;
    i {
      line-height: 0;
      img {
        position: relative;
        margin-top: -3px;
      }
    }
    span {
      height: 35px;
      display: inline-block;
      line-height: 35px;
      background-color: #2c58a6;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      z-index: 1000;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      border-radius: 18px;
      padding: 0 20px;
    }
  }
}
</style>
